import script from "./ATT07_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./ATT07_001INS.vue?vue&type=script&setup=true&lang=js"

import "./ATT07_001INS.vue?vue&type=style&index=0&id=5bcde03f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcde03f"]])

export default __exports__